<template>
  <div style="width: 100vw;height: auto;background-color: #f5f7f9;position: relative;overflow: hidden;display: flex;flex-direction: column;justify-content: center">
    <div class="header">
      <div class="header-icon" ></div>
      <div class="header-title" id="font-test">理化生实验操作考试训练平台（山西专版）</div>
      <div class="header-pic"
           @click="clickZone">
        <div class="user-card"
             ref="user-card-list"
             v-if="showCard">
          <div class="user-card-pic"></div>
          
            <div style='position: absolute;z-index:999'>
              <div class="user-msg" >
                剩余次数：{{count}}次
              </div>
            </div>
          
        </div>
      </div>

    </div>

    <div style="width: 100vw;height: 7vh;display: flex;flex-wrap: nowrap;margin: 0;flex-direction: row">
      <div class="search-action">
        <el-input placeholder="请输入关键词搜索"
                  v-model="searchInput"
                  class="search-input">
          <i slot="suffix"
             class="el-icon-close"
             style="line-height: 1.5vw;height: 1.5vw;cursor: pointer"
             v-if="searchInput.length>0"
             @click="clearInput"></i>
        </el-input>
        <span class="search-btn"
              id="search"
               style="font-size: 14px">开始搜索</span>
      </div>
      <div class="select-subject">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" style="margin-right: 1vw">全选</el-checkbox>
        <el-checkbox-group v-model="checkedSubject" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="city in subjects" :label="city" :key="city">{{city}}</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>


    <div class="card-group">
      <div
        class="card"
        :style="{marginLeft:index%5===0?'6.5vw':''}"
        @click="showImg=true;selectApp=item;testURL=item.platforms[0].app_uri+'/scoring.png'"
        v-if="item.show"
        v-for="(item,index) in appList.filter(data => !searchInput || data.name.toLowerCase().includes(searchInput.toLowerCase()))">
        <div class="card-body" :class="{'physical':item.subject==='物理','chemistry':item.subject==='化学','biology':item.subject==='生物'}">
          <img class="card-img" :src="item['platforms'][0]['preview_img_uri']" alt="图片丢失">
        </div>
        <div class="card-title">{{item.name.length>widthFontCount?item.name.slice(0,widthFontCount)+'...':item.name}}</div>
      </div>


    </div>

    <el-dialog :visible="showImg" :before-close="closeDia" :show-close="true" center width="65%" top="5vh">
      <img   width="100%"  :src="testURL" alt="图片丢失">
      <span slot="footer">
        <el-button @click="openApp">开始实验</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import axios from "axios";
import { MessageBox } from 'element-ui';
import {getShanxiToken, getToken} from "@/utils/auth";
export default {
  name: 'app-list',
  layout:'home',
  asyncData(ctx) {
    let url=encodeURI('https://api.xiyilab.com/v1/apps?page=1&limit=24&usage=山西模考');
    return axios({
      methods: 'get',
      url:url
    }).then(res=>{
      if(res.data.status==='ok'){
        let returnData=[]
        for(let i=0;i<res.data.data.length;i++){
          res.data.data[i]['show']=true
          returnData.push(res.data.data[i])
        }
        return {appList:returnData}
      }
    })
  },
  data(){
    return {
      showCard:false,
      searchInput:'',
      showImg:false,
      recordURL:'https://api.xiyilab.com/v1/agencies/shanxi-card-expend',
      selectApp:'',
      count:'',
      getInfoURL:'https://api.xiyilab.com/v1/agencies/user-shanxi-card',
      widthFontCount:0,
      checkAll: true,
      checkedSubject: ['物理','化学'],
      subjects: ['物理','化学'],
      isIndeterminate: true,
      testURL:''
    }
  },
  created() {
      window.addEventListener('keydown',function (e){
        if(e.keyCode==13){
          document.getElementById('search').click()
        }
      })
      this.$axios.get(this.getInfoURL,{
        headers:{
          'Authorization':'Bearer '+getShanxiToken()
        }
      }).then(res=>{
        this.count=res.data.data['coin']
        console.log(res.data.data)
      })
      let width=window.innerWidth/100*15
      let fontSize=(window.innerWidth/100*0.7)>12?(window.innerWidth/100):12
      this.widthFontCount=width/fontSize-1
  },
  mounted() {
    let that = this
    document.onclick = function () {
      that.$nextTick(() => {
        that.showCard = false
      })
    }
     console.log(this.appList)
  },
  methods:{
    handleCheckAllChange(val) {
      this.checkedSubject = val ? this.subjects : [];
      this.isIndeterminate = false;
      if(this.checkAll){
        for(let i=0;i<this.appList.length;i++){
          this.appList[i].show=true
        }
      }
      else{
        for(let i=0;i<this.appList.length;i++){
          this.appList[i].show=false
        }
      }
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.subjects.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.subjects.length;
      for(let i=0;i<this.appList.length;i++){
        this.appList[i].show = !!this.checkedSubject.find(item => item === this.appList[i].subject);
      }
    },
    closeDia () {
      this.showImg = false
    },
    openApp(){
      MessageBox.alert('进入实验会消耗剩余次数，当前剩余次数：'+this.count, '提示', {
        confirmButtonText: '确定',
        callback: action => {
          console.log(action)
          if(action==='confirm'){
            if(this.count>0){
              this.$axios.put(this.recordURL,{coin:1},{
                headers:{
                  'Authorization':'Bearer '+getShanxiToken()
                }
              }).then(res=>{
                if(res.data.status==='ok'){
                  let url=this.$router.resolve({
                    path:'/custom/shanxi/webGL',
                    query:{
                      name:this.selectApp.name,
                      subject:this.selectApp.subject,
                      grade:this.selectApp.grade,
                      chapter:this.selectApp.chapter,
                      app_uri:this.selectApp.platforms[0].app_uri,
                      app_id:this.selectApp.id,
                      app_platform_id:this.selectApp.platforms[0].id,
                      platform:'webgl',
                      publisher:this.selectApp.publisher
                    }
                  })
                  window.open(url.href,'_blank')
                  this.$axios.get(this.getInfoURL,{
                    headers:{
                      'Authorization':'Bearer '+getShanxiToken()
                    }
                  }).then(res=>{
                    this.count=res.data.data['coin']
                    console.log(res.data.data)
                  })
                }
                else{
                  this.$message.error('当前网络出错，请检查网络后重试')
                  this.closeDia()
                }
              }).catch(e=>{
                this.$message.error('当前网络出错，请检查网络后重试')
                this.closeDia()
              })
            }
            else{
              this.$message.error('剩余次数不足')
            }
          }
          this.showImg=false
        }
      });
    },
    clearInput(){
      this.searchInput=''
    },
    clickZone(e){
      e.stopPropagation ? e.stopPropagation() : e.cancelBubble = true;
      this.showCard = !this.showCard
    }
  }
}
</script>

<style scoped>
*{
  font-family: test;
}
.card-group {
  width:100vw;
  height: 80vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  overflow: auto;
}
.card-group::-webkit-scrollbar{
  background: transparent;
  width: 10px;
  height: 10px;
  border-radius: 10px;
}
.card-group::-webkit-scrollbar-thumb{
  background-color: rgba(0,0,0,.2);
  width: 10px;
  height: 10px;
  border-radius: 10px;
}
.card-group::-webkit-scrollbar-button{
  display: none;
}
.card-group::-webkit-scrollbar-track{
  display: none;
}
.card{
  margin: 1vw 1.5vw 1vw;
  height: 22vh;
  width: 15vw;
  background-color: white;
  cursor: pointer;
  transition: all .3s;
  border-radius: 8px;
}
.card:hover{
  transform: scale(1.1);
}
.card:hover .card-title{
  color: #5eb2f7;
}
.header {
  width: 100%;
  height: 8vh;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  background-color: white;
}
.header-icon {
  width: 6vw;
  height: 3vw;
  margin-top: 0.5vw;
  margin-left: 3vw;
  background-image: url("http://data.xiyilab.com/web/main/static/首页/资源 2.png");
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
}
.header-pic {
  height: 2vw;
  width: 2vw;
  margin-top: 1vw;
  margin-right: 3vw;
  margin-left: 3vw;
  border-radius: 50%;
  background-image: url("http://data.xiyilab.com/web/main/static/home/小头像.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  position: relative;
}
.user-card {
  position: absolute;
  top: 3vw;
  right: -1vw;
  min-width: 100px;
  max-width: 200px;
  width: 8vw;
  display: flex;
  flex-direction: column;
  z-index: 999;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.user-card-pic {
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  max-height: 120px;
  background-image: url("http://data.xiyilab.com/web/main/static/home/p__卡片背景.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.user-msg {
  display: flex;
  flex-direction: column;
  width: 8vw;
  height: 4vw;
  min-width: 100px;
  min-height: 40px;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 0.7vw;
}

.header-title {
  margin: 1vw auto;
  height: 2vw;
  line-height: 2vw;
  font-size: 1.2vw;
  text-align: center;
}
.select-subject{
  height: 5vh;
  margin-top: 2vh;
  margin-left: auto;
  margin-right: 6.5vw;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}
.search-action {

  height: 5vh;
  width: 20vw;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  margin-left: 6.5vw;
  margin-top: 2vh;

}
.search-input {
  width: 10vw;
  min-width: 200px;
  height: 1.5vw;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 1vw;
}

.search-btn {
  height: 1.5vw;
  width: 8rem;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 40px;
  line-height: 1.5vw;
  display: inline-block;
  background-color: #5eb2f7;
  color: white;
  border: none;
  text-align: center;
  white-space: nowrap;
  margin-right: 1vw;
  font-size: 0.7vw;
  cursor: pointer;
}
.total-span {
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 0.8vw;
}
.el-input--medium,
/deep/ .el-input__inner {
  border: none;
  border-radius: 1.5vw;
  height: 1.5vw;
}
.physical{
  background-image: url("http://data.xiyilab.com/web/main/static/实验/物理.png");
  width: 15vw;
  height: 9vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.chemistry{
  background-image: url("http://data.xiyilab.com/web/main/static/实验/化学.png");
  width: 15vw;
  height: 9vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.biology{
  background-image: url("http://data.xiyilab.com/web/main/static/实验/生物.png");
  width: 15vw;
  height: 18vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

}
.card-body{
  display: flex;
  align-content: center;
  justify-content: center;
  border-radius: 8px 8px 0 0;
}
.card-img{
  width: 16vh;
  height: 16vh;
}
.card-title{
  height: 4vh;
  line-height: 4vh;
  text-align: center;
  width: 15vw;
  font-size: 0.8vw;
  font-family: test;
  color: black;
}
</style>
